export default {
  // connection id for websockets
  connectionID: null,
  webSocket: null,
  currentState: null,
  activeSubscriptions: [],

  // these are the handlers that define what happens when we recieve a message of a certain type
  socketEventHandlers: {},

  // these are the subscriptions we have to maintain when the websocket is created/recreated 
  socketSubscriptions: []
}